import React from 'react';

import { Config } from '@vm/omega-shared-component-webapp';
import styled from '@emotion/styled';

import { StyleLibrary } from '@vm/omega-shared-component-webapp';
import { PaletteColors } from '../../components/helpers/paletteHelpers';
const { mqBreakpoints, pxToRem } = StyleLibrary;

const BackgroundContainer = styled.div([
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: pxToRem(16) + ' ' + pxToRem(32),

    [mqBreakpoints.desktop]: {
      padding: pxToRem(96),
    },
  },
]);

const LogoContainer = styled.div([
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: pxToRem(312),
    height: pxToRem(312),

    [mqBreakpoints.tablet]: {
      width: pxToRem(458),
      height: pxToRem(458),
    },

    [mqBreakpoints.desktop]: {
      width: pxToRem(530),
      height: pxToRem(530),
    },
  },
]);

const Img = styled.img({
  maxWidth: '100%',
});

type Props = {
  logo: string;
  paletteColors: PaletteColors;
};

export const BenefitsLogo: React.FC<Props> = ({ logo, paletteColors }) => {
  return (
    <BackgroundContainer style={{ background: `${paletteColors.paletteBackgroundColor}` }}>
      <LogoContainer>
        <Img src={`${Config.get('image_cdn_base_url')}/${logo}`} alt='Product photo' data-testid='mp-product-benefits-logo' />
      </LogoContainer>
    </BackgroundContainer>
  );
};
